import React from "react";

import { networkErrorImage } from "@ippon/shared-assets";

import PageError from "./PageError";

export interface NetworkErrorProps {
  actionLabel?: string;
  onRetry?: () => void;
}

const NetworkError: React.FC<NetworkErrorProps> = ({
  actionLabel = "再読み込み",
  onRetry = () => {
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  },
}) => {
  return (
    <PageError
      actionLabel={actionLabel}
      imageSrc={networkErrorImage}
      message="接続状況を確認して再試行してください。"
      onRetry={onRetry}
      statusCode="Network Error"
      title="通信に失敗しました"
    />
  );
};

export default NetworkError;
